import React from 'react'

import styles from './style.module.css'

/**
 * 納品先連携機能が無効（区分 OFF）なテナント向けの案内表示。
 *
 * 納品実績の一覧・詳細で共通して使う。問い合わせ先（TEL / メール）を含む。
 * Figma 3138-5865 準拠。余白は配置する側で制御する（本コンポーネントは
 * 最外要素に margin を持たない）。
 */
export const DeliveryLinkageFeatureOffNotice: React.FC = () => (
  <div className={styles.overlay}>
    <p className={styles.title}>この区分では納品先連携を使用できません。</p>
    <p className={styles.desc}>
      本機能により、ドライバーの方々の納品状況を確認することが可能になりますので、
      ご興味のある方は下記へお問い合わせください。
    </p>
    <div className={styles.contact}>
      <span className={styles.tel}>TEL：0120-507-765</span>
      <span>
        メール：
        <a href="mailto:tb-customer-success@hacobell.co.jp" className={styles.mail}>
          tb-customer-success@hacobell.co.jp
        </a>
      </span>
    </div>
  </div>
)
